import { DocumentFragment } from '@/__generated__/graphql';
import {
  deleteUndefined,
  firstNonNullable,
  humanFileSize,
  makeNonNullableArray,
  toStringOrNull,
} from '@liquorice/allsorts-craftcms-nextjs';

export type DocumentAsset = NonNullable<ReturnType<typeof parseDocument>>;

export const parseDocument = (maybeElement?: MaybeArrayOf<Partial<DocumentFragment>>) => {
  const doc = firstNonNullable(maybeElement);
  if (!doc) return null;
  const { size, ...rest } = doc;

  // const summary = toStringOrNull(maybeGet(doc, 'summary')) ?? undefined;
  const title = toStringOrNull(doc.title) ?? undefined;
  const id = toStringOrNull(doc.id) ?? undefined;

  return deleteUndefined({
    ...rest,
    id,
    title,
    /* summary, */
    size,
    sizeHuman: humanFileSize(size),
  });
};

export const parseDocumentMany = (maybeElements?: MaybeArrayOf<DocumentFragment>) => {
  return makeNonNullableArray(maybeElements).reduce((results, item) => {
    const asset = parseDocument(item);
    if (asset) results.push(asset);
    return results;
  }, [] as DocumentAsset[]);
};
